import React, { Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';
import { motion } from 'framer-motion';
import { pageVariants } from './utils/animations';

// Lazy load pages
const Home = React.lazy(() => import('./pages/Home'));
const Solutions = React.lazy(() => import('./pages/Solutions'));
const Products = React.lazy(() => import('./pages/Products'));
const Pricing = React.lazy(() => import('./pages/Pricing'));
const About = React.lazy(() => import('./pages/About'));
const Blog = React.lazy(() => import('./pages/Blog'));
const Careers = React.lazy(() => import('./pages/Careers'));
const Contact = React.lazy(() => import('./pages/Contact'));
const Waitlist = React.lazy(() => import('./pages/Waitlist'));

// Lazy load solution pages
const ClinicalWorkflow = React.lazy(() => import('./pages/solutions/ClinicalWorkflow'));
const PatientEngagement = React.lazy(() => import('./pages/solutions/PatientEngagement'));
const Analytics = React.lazy(() => import('./pages/solutions/Analytics'));

// Lazy load product pages
const AIPlatform = React.lazy(() => import('./pages/products/AIPlatform'));
const ClinicalTools = React.lazy(() => import('./pages/products/ClinicalTools'));
const IntegrationHub = React.lazy(() => import('./pages/products/IntegrationHub'));

// Loading fallback component
const LoadingFallback = () => (
  <div className="flex h-screen items-center justify-center">
    <div className="h-32 w-32 animate-spin rounded-full border-b-2 border-primary-600"></div>
  </div>
);

// Page wrapper component for animations
const PageWrapper = ({ children }: { children: React.ReactNode }) => (
  <motion.div
    initial="initial"
    animate="enter"
    exit="exit"
    variants={pageVariants}
    className="min-h-screen"
  >
    {children}
  </motion.div>
);

function Routers() {
  return (
    <Suspense fallback={<LoadingFallback />}>
      <Routes>
        <Route
          path="/"
          element={<PageWrapper><Home /></PageWrapper>}
        />
        <Route
          path="/solutions"
          element={<PageWrapper><Solutions /></PageWrapper>}
        />
        <Route
          path="/products"
          element={<PageWrapper><Products /></PageWrapper>}
        />
        <Route
          path="/pricing"
          element={<PageWrapper><Pricing /></PageWrapper>}
        />
        <Route
          path="/about"
          element={<PageWrapper><About /></PageWrapper>}
        />
        {/* Solutions subpages */}
        <Route path="/solutions/ai-diagnostics" element={<PageWrapper><Solutions /></PageWrapper>} />
        <Route path="/solutions/clinical-workflow" element={<PageWrapper><ClinicalWorkflow /></PageWrapper>} />
        <Route path="/solutions/patient-engagement" element={<PageWrapper><PatientEngagement /></PageWrapper>} />
        <Route path="/solutions/analytics" element={<PageWrapper><Analytics /></PageWrapper>} />
        {/* Products subpages */}
        <Route path="/products/ai-platform" element={<PageWrapper><AIPlatform /></PageWrapper>} />
        <Route path="/products/clinical-tools" element={<PageWrapper><ClinicalTools /></PageWrapper>} />
        <Route path="/products/integration-hub" element={<PageWrapper><IntegrationHub /></PageWrapper>} />
        <Route path="/products/api" element={<PageWrapper><Products /></PageWrapper>} />
        <Route
          path="/blog"
          element={<PageWrapper><Blog /></PageWrapper>}
        />
        <Route
          path="/careers"
          element={<PageWrapper><Careers /></PageWrapper>}
        />
        <Route
          path="/contact"
          element={<PageWrapper><Contact /></PageWrapper>}
        />
        <Route
          path="/waitlist"
          element={<PageWrapper><Waitlist /></PageWrapper>}
        />
      </Routes>
    </Suspense>
  );
}

export default Routers;
